// Thư mục: src/services/baoDuongXeService.js
import api from "@/api";

const BASE_URL = "/api/bao-duong-xe";

/**
 * API service cho Quản lý Phiếu Bảo dưỡng/Sửa chữa
 */
export const BaoDuongXeApi = {
  // === API DANH SÁCH CHÍNH ===
  /**
   * Lấy danh sách phiếu bảo dưỡng (phân trang)
   * params: { q?, trangThai?, page?, size?, sort? }
   */
  listAll(params = { page: 0, size: 10, sort: "ngayTao,desc" }) {
    return api.get(BASE_URL, { params }).then((res) => res.data);
  },

  /**
   * Giai đoạn 1: Tạo Phiếu Sửa Chữa Mới
   * @param {object} payload - BaoDuongXeCreateRequest
   */
  create(payload) {
    return api.post(BASE_URL, payload).then((res) => res.data);
  },

  /**
   * Giai đoạn 2 (luồng mới):
   * Chọn Hướng xử lý + (optional) Gara + Giá dự kiến + Ảnh báo giá
   * Sau đó Backend sẽ chuyển MỚI -> ĐANG_SỬA
   *
   * @param {number} id - ID Phiếu
   * @param {object} payload - BaoGiaSubmitRequest {
   *    huongXuLy?: 'MUA_PHU_TUNG' | 'RA_GARA' | 'DAT_LICH_SAU',
   *    garaDeXuat?: string,
   *    giaDeXuat?: number,
   *    anhBaoGiaUrl?: string
   * }
   */
  submitBaoGia(id, payload) {
    return api
      .post(`${BASE_URL}/${id}/bao-gia`, payload)
      .then((res) => res.data);
  },

  /**
   * (Luồng cũ) Lấy Giá Tham Khảo theo Hạng mục
   * Vẫn giữ nếu có chỗ khác dùng, FE mới có thể bỏ.
   */
  getGiaThamKhao(dmHangMucId) {
    return api
      .get(`${BASE_URL}/gia-tham-khao`, { params: { dmHangMucId } })
      .then((res) => res.data);
  },

  /**
   * (Luồng cũ) Admin Duyệt Báo Giá
   * Luồng mới không dùng, giữ cho tương thích.
   */
  duyetBaoGia(id) {
    return api.post(`${BASE_URL}/${id}/duyet`).then((res) => res.data);
  },

  /**
   * (Luồng cũ) Bắt đầu Sửa chữa sau khi đã duyệt
   * Luồng mới không dùng, giữ cho tương thích.
   */
  batDauSuaChua(id) {
    return api.post(`${BASE_URL}/${id}/bat-dau`).then((res) => res.data);
  },

  /**
   * Giai đoạn 4: Tài xế Hoàn thành Sửa chữa
   * @param {number} id
   * @param {object} payload - HoanThanhSuaChuaRequest {
   *    odoHoanThanh: number,
   *    chiPhiThucTe: number,
   *    bienLaiUrl: string
   * }
   */
  hoanThanhSuaChua(id, payload) {
    return api
      .post(`${BASE_URL}/${id}/hoan-thanh`, payload)
      .then((res) => res.data);
  },

  /**
   * Giai đoạn 5: Admin/Kế toán Xác nhận Thanh toán
   * @param {number} id
   * @param {string} [ghiChu]
   */
  xacNhanThanhToan(id, ghiChu) {
    const params = {};
    if (ghiChu) params.ghiChu = ghiChu;
    return api
      .post(`${BASE_URL}/${id}/xac-nhan-thanh-toan`, null, { params })
      .then((res) => res.data);
  },

  /**
   * Hủy phiếu
   * @param {number} id
   * @param {string} lyDoHuy
   */
  huyPhieu(id, lyDoHuy) {
    return api
      .post(`${BASE_URL}/${id}/huy`, null, { params: { lyDoHuy } })
      .then((res) => res.data);
  },

  /**
   * Lấy chi tiết 1 phiếu theo ID (kèm messages)
   */
  getById(id) {
    return api.get(`${BASE_URL}/${id}`).then((res) => res.data);
  },

  /**
   * Lấy lịch sử bảo dưỡng theo Xe (phân trang)
   */
  getLichSuByXeId(xeId, params = { page: 0, size: 10, sort: "ngayTao,desc" }) {
    return api
      .get(`${BASE_URL}/lich-su/theo-xe/${xeId}`, { params })
      .then((res) => res.data);
  },

  // === API PHỤ TRỢ (Options cho Modal) ===

  /**
   * Lấy danh sách Xe (ID, Biển số) cho dropdown
   */
  getXeOptions() {
    return api.get("/api/xe/options").then((res) => res.data);
  },

  /**
   * Lấy danh sách Hạng mục Bảo dưỡng (ID, Tên) cho dropdown
   */
  getDmBaoDuongOptions() {
    return api
      .get("/api/dm-hang-muc-bao-duong/active-options")
      .then((res) => res.data);
  },

  // === SOS / Méo mó cuộc đời ===
  createFromSos(payload) {
    return api.post(`${BASE_URL}/su-co-sos`, payload).then((res) => res.data);
  },

  getDriverTickets() {
    return api.get(`${BASE_URL}/cua-toi`).then((res) => res.data);
  },

  // === CHAT ===
  sendChat(ticketId, payload) {
    // payload: { text: string, system?: boolean }
    return api
      .post(`${BASE_URL}/${ticketId}/chat`, payload)
      .then((r) => r.data);
  },

  getChat(ticketId) {
    return api.get(`${BASE_URL}/${ticketId}/chat`).then((r) => r.data);
  },

  /**
   * Chuyển trạng thái bằng command/chat (chuyển tự do)
   */
  chuyenTrangThai(id, action) {
    return api
      .post(`${BASE_URL}/${id}/chuyen-trang-thai`, null, {
        params: { action },
      })
      .then((r) => r.data);
  },
};
